import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import get from "lodash/get";
import { object } from "prop-types";
import { AppLogo } from "../app-logo";

import "./footer.m.css";
import RadioPlayerCustomV3 from "../../molecules/radio-player-custom-v3";

import { getProcessedSocialLinks } from "./utils";

const FooterBase = ({ menu, pageType, socialLinks, publisherSettings }) => {
  const { copyright } = publisherSettings;
  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowButton(window.scrollY > 300);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const processedLinks = getProcessedSocialLinks(socialLinks);

  const groupedMenu = menu.map((item) => ({
    title: item.title,
    children: item.children || [],
  }));

  const menuColumns = [];
  for (let i = 0; i < groupedMenu.length; i += 2) {
    menuColumns.push(groupedMenu.slice(i, i + 2));
  }

  return (
    <div>
      <div styleName="footer">
        <div styleName="icons-wrapper">
          <div styleName="main-logo">
            <AppLogo />
            <style>
              {`
                #footer .app-logo {
                  height: 110px;
                }
                @media only screen and (max-width: 640px) {
                  #footer .app-logo {
                    height: 80px;
                  }
                }
              `}
            </style>
          </div>

          <div styleName="social-icons">
            {processedLinks.map((link) => (
              <a key={link.platform} target="_blank" href={link.url}>
                <i className={link.iconClass}></i>
              </a>
            ))}
          </div>
        </div>

        <div styleName="footer-lists-container">
          {menuColumns?.map((columnSections, columnIndex) => (
            <div styleName="list-groups" key={columnIndex}>
              {columnSections?.map((section, sectionIndex) => (
                <div styleName="footer-section" key={sectionIndex}>
                  <h2>{section?.title}</h2>
                  <div styleName="links-style-wrapper">
                    {section?.children?.map((item, itemIndex) => (
                      <a
                        key={itemIndex}
                        styleName="style-links"
                        href={item?.completeUrl || item?.url}
                      >
                        {item?.title}
                      </a>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          ))}
        </div>

        <div styleName="footer-section ylos-custom">
          <div styleName="links-style-wrapper">
            {showButton && (
              <button
                styleName="up-button-mobile"
                onClick={() =>
                  window.scroll({
                    top: 0,
                    left: 0,
                    behavior: "smooth",
                  })
                }
              >
                <div styleName="up-button-text">
                  YLÖS <i className="ri-arrow-up-line"></i>
                </div>
              </button>
            )}
          </div>
        </div>

        <div styleName="copyright-info">
          {copyright}
        </div>
      </div>
      <div styleName="footer-section" style={{ position: "relative", zIndex: 99999 }}>
        <RadioPlayerCustomV3 pageType={pageType} />
      </div>
    </div>
  );
};

function mapStateToProps(state) {
  return {
    menu: get(state, ["qt", "data", "navigationMenu", "footer"], []),
    pageType: get(state, ["qt", "pageType"], null),
    socialLinks: get(state, ["qt", "config", "social-links"], {}),
    publisherSettings: get(state, ["qt", "config", "publisher-settings"], {}),
  };
}

FooterBase.propTypes = {
  menu: object,
};

export const Footer = connect(mapStateToProps, null)(FooterBase);
